import { gql } from '@apollo/client'

export const GET_ALL_PROCESSES_CATEGORIES = gql`
  query GetAllProcessesCategories(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filterCategory: Boolean
    $processId: Int
  ) {
    getAllProcessesCategories(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filterCategory: $filterCategory
      processId: $processId
    ) {
      count
      rows {
        id
        name
        processes_id
        description
      }
    }
  }
`

export const GET_ONE_PROCESS_CATEGORIES_BY_ID = gql`
  query GetProcessCategoryById($getProcessCategoryByIdId: Int!) {
    getProcessCategoryById(id: $getProcessCategoryByIdId) {
      id
      name
      description
    }
  }
`

export const GET_ALL_PROCESSES_TYPES_BY_PROCESS_ID = gql`
  query GetAllProcessesCategoriesByProcessId($processId: Int!) {
    getAllProcessesCategoriesByProcessId(process_id: $processId) {
      id
      name
      description
    }
  }
`

export const GET_ALL_PROCESSES_WITH_SUBCATEGORIES_BY_CONTEXT = gql`
  query GetAllProcessesCategoriesAndSubCategoriesByContext {
    getAllProcessesCategoriesAndSubCategoriesByContext {
      id
      name
      ProcessesCategoriesToSubCategories {
        id
        name
      }
    }
  }
`
